<script setup>

import { inject, ref } from 'vue';
import ModaleAjoutDimension from '@/components/modales/ModaleAjoutDimension.vue';

import Listbox from 'primevue/listbox';
import Dimension from './Dimension.vue';

const { dimensions } = defineProps({
	dimensions: Array
});

const affichageModaleAjoutDimension = ref(false);

const selectionSchema = inject('selectionSchema');
const ouvrirFenetreFormule = inject('ouvrirFenetreFormule');

function afficherModaleAjoutDimension() {
	affichageModaleAjoutDimension.value = true;
}

function gererAjoutDimension(nomDimension) {
	const nouvelleDimension = dimensions.find(dim => dim.nom === nomDimension);
	selectionSchema.value.dimension = nouvelleDimension;
	if (nouvelleDimension.modeEvaluation === 'CALCUL') {
		ouvrirFenetreFormule(nouvelleDimension, true);
	}
}

</script>

<template>
	<div>
		<div class="entete">
			<label class="titre">Dimensions</label>
			<div class="conteneur-boutons">
				<button class="bouton fa-solid fa-plus" @click="afficherModaleAjoutDimension()" />
			</div>
		</div>
		<Listbox class="liste-dimensions" 
		  v-model="selectionSchema.dimension" 
		  :options="dimensions"
		  :selectOnFocus="true"
		  :emptyMessage="'Aucune dimension'"
		  :optionLabel="'nom'"
		  :disabled="!dimensions.length">
			<template #option="slotProps">
				<Dimension :dimension="slotProps.option" :selectionnee="slotProps.option == selectionSchema.dimension"/>
			</template>
		</Listbox>
		<ModaleAjoutDimension 
			v-if="affichageModaleAjoutDimension"
			:dimension="{}" 
			@fermeture="affichageModaleAjoutDimension = false"
			@ajoutDimension="gererAjoutDimension" />
	</div>
</template>

<style scoped>

.liste-dimensions {
	height: 15vh !important;
	overflow: auto;
}

.entete {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin: 2px;
}

</style>